    <!-- Navigation -->
    <header class="fixed-bottom" id="bottomPlayer">
      <div class="player-container">
        <iframe style="display:block; margin: 0 auto; border: 0; width: 100%; height: 42px; background-color: white;" src="https://bandcamp.com/EmbeddedPlayer/album=982300105/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="https://brianalanhager.bandcamp.com/album/rock-and-soul">Rock and Soul by Brian Alan Hager</a></iframe>
      </div>
    </header>

